import { useContext, useState, FC, useEffect } from 'react'

import { CostCenter, CostCenterFilterKeyString } from 'InstitutionalManagement/types'
import { COST_CENTER_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/costCenters'
import CustomFormCostCenterSelectionDrawerManagerContext from './Context'
import readCostCentersOnCustomForm from './services/readCostCentersOnCustomForm'

type Props = {
  questionKey: string
  children: JSX.Element
}

const CustomFormCostCenterSelectionDrawerManagerProvider: FC<Props> = ({ questionKey, children }) => {
  const [view, setView] = useState<string>('SEARCH_COST_CENTER')
  const [selectedCostCenter, setSelectedCostCenter] = useState<CostCenter>({})
  const [loadingCostCenters, setLoadingCostCenters] = useState<boolean>(true)
  const [costCenters, setCostCenters] = useState<CostCenter[]>([])
  const [filter, setFilter] = useState<CostCenterFilterKeyString>(COST_CENTER_INITIAL_FILTER)

  async function loadCostCenter() {
    setLoadingCostCenters(true)
    const filters = {
      filter,
      pagination: {
        page: 1,
        limit: 0,
      },
    }

    const response = await readCostCentersOnCustomForm({ filters })

    if (response?.header?.success) {
      const costCentersFromAPI = response?.body?.cost_center?.elements
      setCostCenters(costCentersFromAPI || [])
    }
    setLoadingCostCenters(false)
  }

  useEffect(() => {
    if (view != 'SEARCH_COST_CENTER') loadCostCenter()
  }, [filter])

  return (
    <CustomFormCostCenterSelectionDrawerManagerContext.Provider
      value={{
        view,
        setView,
        selectedCostCenter,
        setSelectedCostCenter,
        filter,
        setFilter,
        questionKey,
        costCenters,
        loadingCostCenters,
        setLoadingCostCenters,
      }}
    >
      {children}
    </CustomFormCostCenterSelectionDrawerManagerContext.Provider>
  )
}

export const useCustomFormCostCenterSelectionDrawerManager = () =>
  useContext(CustomFormCostCenterSelectionDrawerManagerContext)

export default CustomFormCostCenterSelectionDrawerManagerProvider
